import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { saga } from "./saga";
import { IAggregationRowState } from "./types";

export {
    createClearAggregationRowAction,
    createColumnAddedAction,
    createColumnDefinitionsChangedAction,
    createColumnRemovedAction,
    createColumnWidthChangedAction,
    createFilterChangedAction,
    createInitAggregationRowAction,
    createNumberOfFrozenColumnsChangedAction,
    createOrderOfColumnsChangedAction,
    createReloadAggregationResultsAction,
} from "./actions";
export { AggregationRow } from "./components";
export { CLOSE_BUTTON_ACTIVATED } from "./constants";
export { unsafeGetAllColumnsAggregationFunctions, unsafeGetColumnsAggregationFunctions } from "./selectors";
export { AggregationRowKey, ColumnAggregationFunctions, ColumnDefinition, ColumnKey, ColumnType, Filter, ICloseButtonActivatedAction } from "./types";
export { areFiltersEqual } from "./utils";

export const aggregationRowModule: ApplicationStatefulModule<typeof NAME, Reducer<IAggregationRowState>> = {
    NAME,
    reducer,
    saga,
};
